module.exports = __webpack_public_path__ + "media/bootstrap-icons/flower1-981f9e86.svg";